var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166 258",
    width: 166,
    height: 258,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -406.5, -305.84375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "artboard",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M422.812500,414.750000C431.813489,414.750000 439.125000,422.061511 439.125000,431.062500 C439.125000,440.063489 431.813489,447.375000 422.812500,447.375000 C413.811511,447.375000 406.500000,440.063489 406.500000,431.062500 C406.500000,422.061511 413.811511,414.750000 422.812500,414.750000 L 422.812500,414.750000 ZM422.812500,414.750000C431.813489,414.750000 439.125000,422.061511 439.125000,431.062500 C439.125000,440.063489 431.813489,447.375000 422.812500,447.375000 C413.811511,447.375000 406.500000,440.063489 406.500000,431.062500 C406.500000,422.061511 413.811511,414.750000 422.812500,414.750000 L 422.812500,414.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M466.812500,414.750000C475.813489,414.750000 483.125000,422.061511 483.125000,431.062500 C483.125000,440.063489 475.813489,447.375000 466.812500,447.375000 C457.811511,447.375000 450.500000,440.063489 450.500000,431.062500 C450.500000,422.061511 457.811511,414.750000 466.812500,414.750000 L 466.812500,414.750000 ZM466.812500,414.750000C475.813489,414.750000 483.125000,422.061511 483.125000,431.062500 C483.125000,440.063489 475.813489,447.375000 466.812500,447.375000 C457.811511,447.375000 450.500000,440.063489 450.500000,431.062500 C450.500000,422.061511 457.811511,414.750000 466.812500,414.750000 L 466.812500,414.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M511.812500,414.750000C520.813489,414.750000 528.125000,422.061511 528.125000,431.062500 C528.125000,440.063489 520.813489,447.375000 511.812500,447.375000 C502.811511,447.375000 495.500000,440.063489 495.500000,431.062500 C495.500000,422.061511 502.811511,414.750000 511.812500,414.750000 L 511.812500,414.750000 ZM511.812500,414.750000C520.813489,414.750000 528.125000,422.061511 528.125000,431.062500 C528.125000,440.063489 520.813489,447.375000 511.812500,447.375000 C502.811511,447.375000 495.500000,440.063489 495.500000,431.062500 C495.500000,422.061511 502.811511,414.750000 511.812500,414.750000 L 511.812500,414.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M555.812500,414.750000C564.813489,414.750000 572.125000,422.061511 572.125000,431.062500 C572.125000,440.063489 564.813489,447.375000 555.812500,447.375000 C546.811511,447.375000 539.500000,440.063489 539.500000,431.062500 C539.500000,422.061511 546.811511,414.750000 555.812500,414.750000 L 555.812500,414.750000 ZM555.812500,414.750000C564.813489,414.750000 572.125000,422.061511 572.125000,431.062500 C572.125000,440.063489 564.813489,447.375000 555.812500,447.375000 C546.811511,447.375000 539.500000,440.063489 539.500000,431.062500 C539.500000,422.061511 546.811511,414.750000 555.812500,414.750000 L 555.812500,414.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M466.812500,490.750000C475.813489,490.750000 483.125000,498.061511 483.125000,507.062500 C483.125000,516.063489 475.813489,523.375000 466.812500,523.375000 C457.811511,523.375000 450.500000,516.063489 450.500000,507.062500 C450.500000,498.061511 457.811511,490.750000 466.812500,490.750000 L 466.812500,490.750000 ZM466.812500,490.750000C475.813489,490.750000 483.125000,498.061511 483.125000,507.062500 C483.125000,516.063489 475.813489,523.375000 466.812500,523.375000 C457.811511,523.375000 450.500000,516.063489 450.500000,507.062500 C450.500000,498.061511 457.811511,490.750000 466.812500,490.750000 L 466.812500,490.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M511.812500,490.750000C520.813489,490.750000 528.125000,498.061511 528.125000,507.062500 C528.125000,516.063489 520.813489,523.375000 511.812500,523.375000 C502.811511,523.375000 495.500000,516.063489 495.500000,507.062500 C495.500000,498.061511 502.811511,490.750000 511.812500,490.750000 L 511.812500,490.750000 ZM511.812500,490.750000C520.813489,490.750000 528.125000,498.061511 528.125000,507.062500 C528.125000,516.063489 520.813489,523.375000 511.812500,523.375000 C502.811511,523.375000 495.500000,516.063489 495.500000,507.062500 C495.500000,498.061511 502.811511,490.750000 511.812500,490.750000 L 511.812500,490.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M444.812500,375.750000C453.813489,375.750000 461.125000,383.061511 461.125000,392.062500 C461.125000,401.063489 453.813489,408.375000 444.812500,408.375000 C435.811511,408.375000 428.500000,401.063489 428.500000,392.062500 C428.500000,383.061511 435.811511,375.750000 444.812500,375.750000 L 444.812500,375.750000 ZM444.812500,375.750000C453.813489,375.750000 461.125000,383.061511 461.125000,392.062500 C461.125000,401.063489 453.813489,408.375000 444.812500,408.375000 C435.811511,408.375000 428.500000,401.063489 428.500000,392.062500 C428.500000,383.061511 435.811511,375.750000 444.812500,375.750000 L 444.812500,375.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M488.812500,375.750000C497.813489,375.750000 505.125000,383.061511 505.125000,392.062500 C505.125000,401.063489 497.813489,408.375000 488.812500,408.375000 C479.811511,408.375000 472.500000,401.063489 472.500000,392.062500 C472.500000,383.061511 479.811511,375.750000 488.812500,375.750000 L 488.812500,375.750000 ZM488.812500,375.750000C497.813489,375.750000 505.125000,383.061511 505.125000,392.062500 C505.125000,401.063489 497.813489,408.375000 488.812500,408.375000 C479.811511,408.375000 472.500000,401.063489 472.500000,392.062500 C472.500000,383.061511 479.811511,375.750000 488.812500,375.750000 L 488.812500,375.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M533.812500,375.750000C542.813489,375.750000 550.125000,383.061511 550.125000,392.062500 C550.125000,401.063489 542.813489,408.375000 533.812500,408.375000 C524.811511,408.375000 517.500000,401.063489 517.500000,392.062500 C517.500000,383.061511 524.811511,375.750000 533.812500,375.750000 L 533.812500,375.750000 ZM533.812500,375.750000C542.813489,375.750000 550.125000,383.061511 550.125000,392.062500 C550.125000,401.063489 542.813489,408.375000 533.812500,408.375000 C524.811511,408.375000 517.500000,401.063489 517.500000,392.062500 C517.500000,383.061511 524.811511,375.750000 533.812500,375.750000 L 533.812500,375.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M444.812500,452.750000C453.813489,452.750000 461.125000,460.061511 461.125000,469.062500 C461.125000,478.063489 453.813489,485.375000 444.812500,485.375000 C435.811511,485.375000 428.500000,478.063489 428.500000,469.062500 C428.500000,460.061511 435.811511,452.750000 444.812500,452.750000 L 444.812500,452.750000 ZM444.812500,452.750000C453.813489,452.750000 461.125000,460.061511 461.125000,469.062500 C461.125000,478.063489 453.813489,485.375000 444.812500,485.375000 C435.811511,485.375000 428.500000,478.063489 428.500000,469.062500 C428.500000,460.061511 435.811511,452.750000 444.812500,452.750000 L 444.812500,452.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M488.812500,452.750000C497.813489,452.750000 505.125000,460.061511 505.125000,469.062500 C505.125000,478.063489 497.813489,485.375000 488.812500,485.375000 C479.811511,485.375000 472.500000,478.063489 472.500000,469.062500 C472.500000,460.061511 479.811511,452.750000 488.812500,452.750000 L 488.812500,452.750000 ZM488.812500,452.750000C497.813489,452.750000 505.125000,460.061511 505.125000,469.062500 C505.125000,478.063489 497.813489,485.375000 488.812500,485.375000 C479.811511,485.375000 472.500000,478.063489 472.500000,469.062500 C472.500000,460.061511 479.811511,452.750000 488.812500,452.750000 L 488.812500,452.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M533.812500,452.750000C542.813489,452.750000 550.125000,460.061511 550.125000,469.062500 C550.125000,478.063489 542.813489,485.375000 533.812500,485.375000 C524.811511,485.375000 517.500000,478.063489 517.500000,469.062500 C517.500000,460.061511 524.811511,452.750000 533.812500,452.750000 L 533.812500,452.750000 ZM533.812500,452.750000C542.813489,452.750000 550.125000,460.061511 550.125000,469.062500 C550.125000,478.063489 542.813489,485.375000 533.812500,485.375000 C524.811511,485.375000 517.500000,478.063489 517.500000,469.062500 C517.500000,460.061511 524.811511,452.750000 533.812500,452.750000 L 533.812500,452.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M488.812500,529.750000C497.813489,529.750000 505.125000,537.061511 505.125000,546.062500 C505.125000,555.063489 497.813489,562.375000 488.812500,562.375000 C479.811511,562.375000 472.500000,555.063489 472.500000,546.062500 C472.500000,537.061511 479.811511,529.750000 488.812500,529.750000 L 488.812500,529.750000 ZM488.812500,529.750000C497.813489,529.750000 505.125000,537.061511 505.125000,546.062500 C505.125000,555.063489 497.813489,562.375000 488.812500,562.375000 C479.811511,562.375000 472.500000,555.063489 472.500000,546.062500 C472.500000,537.061511 479.811511,529.750000 488.812500,529.750000 L 488.812500,529.750000 Z",
    fill: "#FFFFFF",
    stroke: "#212C7C",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M444.812500,392.062500C444.812500,392.062500 511.812500,507.062500 511.812500,507.062500 ",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M488.812500,392.062500C488.812500,392.062500 533.812500,469.062500 533.812500,469.062500 ",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M533.812500,392.062500C533.812500,392.062500 555.812500,431.062500 555.812500,431.062500 ",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M533.812500,392.062500C533.812500,392.062500 466.812500,507.062500 466.812500,507.062500 ",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M488.812500,392.062500C488.812500,392.062500 444.812500,469.062500 444.812500,469.062500 ",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M444.812500,392.062500C444.812500,392.062500 422.812500,431.062500 422.812500,431.062500 ",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M422.812500,431.062500C422.812500,431.062500 488.812500,546.062500 488.812500,546.062500 ",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M555.812500,431.062500C555.812500,431.062500 488.812500,546.062500 488.812500,546.062500 ",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M444.812500,392.062500C444.812500,392.062500 533.812500,392.062500 533.812500,392.062500 ",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M492.875000,371.000000C492.875000,371.000000 521.156250,364.593750 529.593750,343.031250 C538.031250,321.468750 529.125000,305.843750 529.125000,305.843750 C529.125000,305.843750 530.687500,323.343750 508.343750,331.781250 C486.000000,340.218750 492.875000,371.000000 492.875000,371.000000 L 492.875000,371.000000 ZM492.875000,371.000000C492.875000,371.000000 521.156250,364.593750 529.593750,343.031250 C538.031250,321.468750 529.125000,305.843750 529.125000,305.843750 C529.125000,305.843750 530.687500,323.343750 508.343750,331.781250 C486.000000,340.218750 492.875000,371.000000 492.875000,371.000000 L 492.875000,371.000000 Z",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "vector-data",
    d: "M485.675906,371.093750C485.675906,371.093750 464.088117,365.964861 457.647561,348.701769 C451.207005,331.438678 458.005369,318.929192 458.005369,318.929192 C458.005369,318.929192 456.812674,332.939816 473.868220,339.694939 C490.923766,346.450062 485.675906,371.093750 485.675906,371.093750 L 485.675906,371.093750 ZM485.675906,371.093750C485.675906,371.093750 464.088117,365.964861 457.647561,348.701769 C451.207005,331.438678 458.005369,318.929192 458.005369,318.929192 C458.005369,318.929192 456.812674,332.939816 473.868220,339.694939 C490.923766,346.450062 485.675906,371.093750 485.675906,371.093750 L 485.675906,371.093750 Z",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.79bde055c9b42edf80d7fa53f92d796c.svg";
export { ForwardRef as ReactComponent };